<section class="partners__wrapper">
  <div class="container">
    <div class="partners__featured grid">
      <div class="col-12 md:col-6">
        <div class="partners__featured-item">
          <a
            href="https://babolat-tenis.pl/303-padel-rakiety?utm_source=referral&utm_medium=banner&utm_campaign=ligapadla"
            target="_blank">
            <img src="assets/images/partners/reklama-babolat.jpg.webp" alt="Babolat" />
          </a>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div class="partners__featured-item">
          <a
            href="https://www.recman.pl/kolekcje/dtw-tennis-club.html?utm_source=referral&utm_medium=banner&utm_campaign=ligapadla"
            target="_blank">
            <img src="assets/images/partners/reklama-recman.jpg.webp" alt="Recman" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="partners__title">Nasi partnerzy</div>
  <div class="container">
    <div class="partners__block">
      <div class="partners__logo-wrapper bg-transparent babolat">
        <a href="https://babolat-tenis.pl/225-padel" target="_blank">
          <img src="assets/images/partners/LOGO_BABOLAT_150TH.png" alt="Babolat" />
        </a>
      </div>
      <div class="partners__logo-wrapper bg-transparent recman">
        <a href="https://www.recman.pl/" target="_blank">
          <img src="assets/images/partners/recman-ligapadla.png" alt="Recman" />
        </a>
      </div>
      <div class="partners__logo-wrapper bg-transparent tretorn">
        <a href="https://babolat-tenis.pl/4740-pilki-tretorn-serie-padel-control-x3.html" target="_blank">
          <img src="assets/images/partners/tretorn-logo.svg" alt="Tretorn" />
        </a>
      </div>
      <div class="partners__logo-wrapper bg-white plt">
        <a href="https://polskaligatenisa.pl/" target="_blank">
          <img src="assets/images/partners/plt-logo.png" alt="Polska Liga Tenisa" />
        </a>
      </div>
    </div>
  </div>
</section>
